var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13 14.543H3.15V2.45c0-.711.242-1.264.726-1.739C4.36.316 5.005 0 5.651 0h17.52c.727 0 1.373.316 1.857.711h.08c.404.475.727 1.028.727 1.74v12.092h2.019c.646 0 1.13.475 1.13 1.107v9.88c0 .632-.484 1.106-1.13 1.106H1.21C.484 26.636 0 26.162 0 25.53v-9.88c0-.632.484-1.107 1.13-1.107z",
    fill: "#628BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.443 14.54h3.149c.565 0 1.05.475 1.13 1.028a5.6 5.6 0 0 0 1.938 3.32c1.05.87 2.341 1.343 3.795 1.343 1.453 0 2.745-.474 3.713-1.343 1.05-.79 1.777-2.055 2.019-3.4.08-.552.565-.947 1.05-.947h3.148V2.447c0-.316-.08-.553-.323-.79-.242-.237-.484-.316-.807-.316h-17.6c-.324 0-.646.158-.889.316-.242.237-.323.474-.323.79V14.54z",
    fill: "#628BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.704 16.754H2.183V24.5h24.462v-7.746h-4.52a7.22 7.22 0 0 1-2.503 3.794c-1.373 1.185-3.23 1.897-5.168 1.897-2.018 0-3.794-.712-5.247-1.897-1.13-.949-2.019-2.292-2.503-3.794z",
    fill: "#1AC1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.112 3c1.204.002 2.326.265 3.319.968 1.721 1.219 2.294 3.756.34 5.529-.654.592-1.302 1.19-1.958 1.778-.412.368-.67.814-.769 1.35-.027.146-.07.288-.106.431-.173.67-.613.994-1.272.938-.654-.057-1.083-.482-1.122-1.149-.063-1.054.259-1.984 1.03-2.733.601-.584 1.24-1.132 1.855-1.703.164-.152.313-.32.453-.495.734-.921.317-2.289-.923-2.713a2.69 2.69 0 0 0-2.013.093c-.479.214-.75.626-.967 1.065-.172.345-.302.71-.45 1.068-.302.735-.934 1.044-1.653.807-.52-.17-.9-.69-.875-1.225.057-1.136.602-2.037 1.461-2.762 1.044-.883 2.283-1.253 3.65-1.247zM15 17.02c-.008.578-.433.989-1.014.98-.579-.01-.995-.436-.986-1.012.01-.57.458-1 1.035-.988.557.011.973.451.965 1.02z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveConfirmation);
export default __webpack_public_path__ + "static/media/archive-confirmation.b3359f1e548ebb4b1e5e0a6a9e262c12.svg";
export { ForwardRef as ReactComponent };